import { render, staticRenderFns } from "./productSpec.vue?vue&type=template&id=e8e4f60e&"
import script from "./productSpec.vue?vue&type=script&lang=js&"
export * from "./productSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports